import React from 'react'
import { Link } from 'gatsby'

const NavLink = ({ to, static: isStatic, children, ...props }) => {
  if (isStatic) {
    return <a href={to} {...props}>{children}</a>
  }
  return <Link to={to} {...props}>{children}</Link>
}

export default NavLink
